exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".parent[data-v-df17731e]{text-align:center}.parent p[data-v-df17731e]{word-wrap:break-word}._folder[data-v-df17731e]{font-size:80px!important}._folder[data-v-df17731e]:hover{cursor:pointer}._folder-selected[data-v-df17731e],._folder[data-v-df17731e]:hover{color:var(--v-primary-base)}.v-list[data-v-df17731e]{opacity:.8!important}", ""]);

// exports
